import {
  FIND_SYNCHRO_HISTORY_REQUESTED,
  FIND_SYNCHRO_HISTORY_SUCCEEDED,
  FIND_SYNCHRO_HISTORY_FAILED,
  EXECUTE_SYNCHRO_REQUESTED,
  EXECUTE_SYNCHRO_SUCCEEDED,
  EXECUTE_SYNCHRO_FAILED,
  State,
  SynchroActionTypes,
  FIND_SYNCHRO_ONEDRIVE_REQUESTED,
} from './types';

const initialState: State = {
  data: [],
  loading: false,
  executionLoading: false,
  error: null,
};

const reducer = (state = initialState, action: SynchroActionTypes): State => {
  switch (action.type) {
    case FIND_SYNCHRO_HISTORY_REQUESTED:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FIND_SYNCHRO_HISTORY_SUCCEEDED:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case FIND_SYNCHRO_HISTORY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case EXECUTE_SYNCHRO_REQUESTED:
      return {
        ...state,
        executionLoading: true,
        error: null,
      };
    case EXECUTE_SYNCHRO_SUCCEEDED:
      return {
        ...state,
        executionLoading: false,
      };
    case EXECUTE_SYNCHRO_FAILED:
      return {
        ...state,
        executionLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
